import { jsx as _jsx } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { TooltipOrToast } from "@faire/retailer-visitor-shared/components/TooltipOrToast/TooltipOrToast";
import { EXCLUSIVITY_ARTICLE } from "@faire/retailer-visitor-shared/features/Exclusivity/consts";
import { getSettingEnableRetailerExclusivityAgreements } from "@faire/retailer-visitor-shared/settings/getSettingEnableRetailerExclusivityAgreement";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { Button } from "@faire/web--source/slate/Button";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import supportArticle from "@faire/web-api--source/routes/support/articles/articleId";
import * as React from "react";
export var FaireProtectionTooltip = function(props) {
    var strictLocalize = useStrictLocalization().strictLocalize;
    var zipcodeProtectionMessage = strictLocalize({
        id: "ID+6Yz",
        defaultMessage: [
            {
                type: 0,
                value: "A retailer in your zip code currently has exclusivity with this brand."
            }
        ]
    });
    var exclusivityProtectionMessage = strictLocalize({
        id: "Q82tLb",
        defaultMessage: [
            {
                type: 0,
                value: "A retailer in your area currently has exclusivity with this brand."
            }
        ]
    });
    var body = getSettingEnableRetailerExclusivityAgreements() ? exclusivityProtectionMessage : zipcodeProtectionMessage;
    return /*#__PURE__*/ _jsx(TooltipOrToast, {
        hidden: props.hidden,
        pointerOffset: props.pointerOffset,
        position: "top",
        contents: [
            {
                body: body
            }
        ],
        targetNode: props.targetNode,
        primary: true,
        action: /*#__PURE__*/ _jsx(FaireProtectionAction, {}),
        usePortal: props.usePortal,
        "data-test-id": "faire-protection-tooltip",
        portalTooltipYOffset: props.portalTooltipYOffset
    });
};
var FaireProtectionAction = function() {
    var linkTo = getSettingEnableRetailerExclusivityAgreements() ? EXCLUSIVITY_ARTICLE : supportArticle("360016111511");
    return /*#__PURE__*/ _jsx(Button, {
        variant: "tertiary",
        tertiaryColor: Core.text.inverse,
        linkTo: linkTo,
        target: "_blank",
        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "609A3n",
            defaultMessage: [
                {
                    type: 0,
                    value: "Learn more"
                }
            ]
        })
    });
};
